/**
 * Ramp Embed - Entry Point
 */
import { initApi } from "./api";
import { createEmbed } from "./embed";
import { type EmbedConfig } from "./types";

declare const __EMBED_CONFIG__: EmbedConfig;

function main() {
  initApi(__EMBED_CONFIG__);

  const embed = createEmbed({
    container: document.getElementById("app")!,
    config: __EMBED_CONFIG__,
  });

  embed.start();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", main);
} else {
  main();
}
